"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleRecordGeneration = void 0;
const market_rule_base_1 = require("./market-rule-base");
class MarketRuleRecordGeneration extends market_rule_base_1.MarketRuleBase {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.annotation = obj.annotation;
            this.clauseNumber = obj.clauseNumber;
            this.fields = obj.fields;
            this.fieldMap = obj.fieldMap;
            this.fieldAssignments = obj.fieldAssignments;
            this.qualifierFacts = obj.qualifierFacts;
            this.recordType = obj.recordType;
            this.type = obj.type;
        }
    }
}
exports.MarketRuleRecordGeneration = MarketRuleRecordGeneration;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtcmVjb3JkLWdlbmVyYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvc2VydmljZXMvcnVsZS1lbmdpbmUtc2VydmljZS9jbGFzc2VzL21hcmtldC1ydWxlLXJlY29yZC1nZW5lcmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLHlEQUFvRDtBQUVwRCxNQUFhLDBCQUEyQixTQUFRLGlDQUFjO0lBVTFEOzs7T0FHRztJQUNILFlBQW1CLEdBQXlDO1FBQ3hELEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUVYLElBQUksR0FBRyxFQUFFLENBQUM7WUFDTixJQUFJLENBQUMsVUFBVSxHQUFHLEdBQUcsQ0FBQyxVQUFXLENBQUM7WUFDbEMsSUFBSSxDQUFDLFlBQVksR0FBRyxHQUFHLENBQUMsWUFBYSxDQUFDO1lBQ3RDLElBQUksQ0FBQyxNQUFNLEdBQUcsR0FBRyxDQUFDLE1BQU8sQ0FBQztZQUMxQixJQUFJLENBQUMsUUFBUSxHQUFHLEdBQUcsQ0FBQyxRQUFTLENBQUM7WUFDOUIsSUFBSSxDQUFDLGdCQUFnQixHQUFHLEdBQUcsQ0FBQyxnQkFBaUIsQ0FBQztZQUM5QyxJQUFJLENBQUMsY0FBYyxHQUFHLEdBQUcsQ0FBQyxjQUFlLENBQUM7WUFDMUMsSUFBSSxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUMsVUFBVyxDQUFDO1lBQ2xDLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLElBQUssQ0FBQztRQUMxQixDQUFDO0lBQ0wsQ0FBQztDQUNKO0FBNUJELGdFQTRCQyJ9